/**
 * Legacy palette from vanishinginc-dev/magic-conventions/the-retreat-hawaii-2026/Default.aspx
 * (--hawaii-teal, --hawaii-coral, --hawaii-sand, --hawaii-leaf, --hawaii-ink, --hawaii-charcoal)
 */
export const hr = {
  /** Section titles — left accent bar (matches .retreat-section h2) */
  sectionH2:
    'font-serif font-black text-3xl text-[#111827] border-l-[6px] border-[#0F766E] pl-3 border-b-0 mb-4',
  /** Centered page titles (package, pricing, FAQ) */
  sectionH2Center:
    'font-serif font-black text-3xl text-center text-[#111827] border-b-2 border-[#0F766E] pb-2 mb-6',
  /** “Extend the Magic” block — coral accent like #extend on the old site */
  extendH2:
    'font-serif font-black text-3xl text-[#111827] border-l-[6px] border-[#EF4444] pl-3 border-b-0 mb-4',
  h1: 'font-serif font-black text-5xl text-[#111827]',
  subheading: 'font-serif text-xl font-bold mb-2 text-[#1F2937]',
  divider: 'bg-[#0F766E]',
  addOnBg: 'bg-[#F1EDE3]',
  scheduleBlock: 'rounded-lg bg-[#F1EDE3] border border-[#e5e2d9]',
  scheduleTime: 'min-w-14 shrink-0 font-semibold text-[#0F766E]',
  packageNote: 'border border-dashed border-[#0F766E]',
} as const

export const HAWAII_HERO_POSTER =
  'https://vinc.gumlet.io/pics/conventions/hawaii-retreat/hawaii-header.jpg?dpr=2'

export const HAWAII_HERO_VIDEO_SRC =
  'https://videos.hyatt.com/grand_hyatt_kauai_mast.mp4'
